
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<fieldset class=\"checkbox-row {{^visible}}hidden{{/visible}}\" {{#required}}disabled{{/required}}>\n  <label class=\"fxa-checkbox\">\n    <input class=\"permission\" name=\"{{ name }}\" type=\"checkbox\" checked=\"checked\" value=\"{{ name }}\" {{#required}}disabled{{/required}}/>\n\n    {{#valueVisible}}\n      <span class=\"fxa-checkbox__value\">{{ value }}</span>\n      <div class=\"fxa-checkbox__label\">{{ label }}</div>\n    {{/valueVisible}}\n\n    {{^valueVisible}}\n      <span class=\"fxa-checkbox__value\">{{ label }}</span>\n    {{/valueVisible}}\n  </label>\n</fieldset>\n\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/partial/permission.mustache
// module id = 265
// module chunks = app